module.exports = __webpack_public_path__ + "static/media/ruc.ae3ef6c7.png";